<div class="product-slider-container">
    <h2 *ngIf="title1 || title2">{{title1}} <span *ngIf="title2">{{title2}}</span></h2>
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
        <div [ngStyle]="{'margin': '0 ' + divison}" *ngFor="let product of products" ngxSlickItem class="slide" style="outline: none; box-shadow: none;">
            <app-product-slider-item [product]="product"></app-product-slider-item>
        </div>
    </ngx-slick-carousel>
</div>